/* istanbul ignore file */
import { useToken } from '@ori/auth';
import { useEnvironment } from '@ori/environment';
import { useLanguage } from '@ori/i18n';
import { HeadersProvider as Provider } from '@ori/presentation-http';
import type { FC, PropsWithChildren } from 'react';

import { PACKAGE_NAME } from '../constants-generated';

export const HeadersProvider: FC<PropsWithChildren> = ({ children }) => {
  const { language } = useLanguage();
  const { tenant } = useEnvironment();
  const { customerId, token } = useToken();

  return (
    <Provider
      customerId={customerId}
      language={language}
      sourceAppName={PACKAGE_NAME}
      tenant={tenant}
      token={token}
    >
      {children}
    </Provider>
  );
};
